import { getIsPermissionLoading, getIsPermissionReset, getPermissionsList } from '@/queue/ducks/selectors';
import { callToGetPermissionsTabsList, setIsPermissionChanged, setIsPermissionReset, setPermissionConfig } from '@/queue/ducks/slice';
import { ToasterNotification } from '@/toaster/toasterNotification';
import { defaultConfig, tabsLabels, transferTabs } from '@/utils/constants';
import { Box, Spinner, Switch, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';



const Permissions = () => {
    const dispatch = useDispatch();
    const permissionsList = getPermissionsList()
    const isPermissionsListLoading = getIsPermissionLoading()
    const isPermissionsReset = getIsPermissionReset()

    const [permissionConfiguration, setPermissionConfiguration] = useState<any>({})

    useEffect(() => {
        dispatch(callToGetPermissionsTabsList())
        dispatch(setIsPermissionChanged(false));
    }, [])

    useEffect(() => {
        if (isPermissionsReset) {
            if (Object.keys(permissionsList).length > 0) {
                setPermissionConfiguration(permissionsList)
            } else {
                setPermissionConfiguration({})
            }
            dispatch(setIsPermissionReset(false))
        }
    }, [isPermissionsReset, permissionsList])

    useEffect(() => {
        setPermissionConfiguration(permissionsList)
    }, [permissionsList])

    const onChangePermissions = (event: any, prenetKey?: any) => {
        const key = event.target.value;
        const isChecked = event.target.checked;
        let newConfig = []
        if (!prenetKey) {
            if (permissionConfiguration[key] && !Array.isArray(permissionConfiguration[key])) {
                if (key === 'dealerSearch') {
                    newConfig = {
                        ...permissionConfiguration,
                        [key]: Array.isArray(permissionConfiguration[key]) && permissionConfiguration[key].length > 0
                            ? []
                            : defaultConfig[key].filter((feature: string) => feature !== 'IsWildCardSearchAllowed')
                    };
                } else {
                    newConfig = {
                        ...permissionConfiguration,
                        [key]: Object.keys(permissionConfiguration[key])?.length ? {} : defaultConfig[key]
                    };
                }
            } else {
               newConfig = {
                    ...permissionConfiguration,
                    [key]: Array.isArray(permissionConfiguration[key]) && permissionConfiguration[key].length > 0 ? [] : defaultConfig[key],
                };
            }
        } else if (prenetKey) {
            if (prenetKey === 'profileEdit') {
                let parentObject = permissionConfiguration[prenetKey] || {}
                if (isChecked) {
                    if (!parentObject[key]) {
                        parentObject = {
                            ...parentObject,
                            [key]: true
                        }
                    }
                } else {
                    parentObject = {
                        ...parentObject,
                        [key]: false
                    }
                }
                newConfig = {
                    ...permissionConfiguration,
                    [prenetKey]: parentObject
                };
            } else {

                const parentArray = [...(permissionConfiguration[prenetKey] || [])];
                if (prenetKey === 'transfer') {
                    if (!isChecked) {
                        // User is trying to uncheck an option
                        // Check if this would result in both inbound and outbound being unchecked
                        const otherOption = key === 'inbound' ? 'outbound' : 'inbound';
                        const wouldBeBothUnchecked = !parentArray.includes(otherOption) && parentArray.includes(key);
                        
                        if (wouldBeBothUnchecked) {
                            // Show toast message and prevent the action
                            ToasterNotification("error", "At least one option (Inbound or Outbound) must remain selected.");
                            return; // Exit function without making changes
                        }
                    }
                }

                

                if (isChecked) {
                    // Add key if it doesn't exist
                    if (!parentArray.includes(key)) {
                        parentArray.push(key);
                    }
                } else {
                    
                    // Remove key if it exists
                    const index = parentArray.indexOf(key);
                    if (index > -1) {
                        parentArray.splice(index, 1);
                    }
                }
                newConfig = {
                    ...permissionConfiguration,
                    [prenetKey]: parentArray
                };
            }

        }
        
        setPermissionConfiguration(newConfig);
        dispatch(setPermissionConfig(newConfig));
        dispatch(setIsPermissionChanged(true));
    };

    return (
        <Box className='filters-container'>
            <Box className='filter-box-container'>
                <Box className='gray-header'>
                    <Text className='black_label' sx={{ width: '80%' }}>Tabs</Text>
                    <Text className='black_label' sx={{ width: '20%' }}>Hide/View</Text>
                </Box>
                {/* <Box className='blue-header'>
                    <Text className='white_label'>License Type</Text>
                </Box> */}
                {(!isPermissionsListLoading && permissionConfiguration && Object.keys(permissionConfiguration).length > 0) && (
                    <Box className='item-container'>
                        {Object.entries(permissionConfiguration).map(([key, value]) => (
                            <>
                                {key !== 'profileEdit' ?
                                    <>
                                        <Box key={key} className='item-row'>
                                            <Text className='filter_text' sx={{ width: '80%' }}>{tabsLabels[key]}</Text>
                                            <Box sx={{ width: '20%' }}>
                                                <Switch
                                                    size="md"
                                                    colorScheme="facebook"
                                                    value={key}
                                                    onChange={(e) => onChangePermissions(e)}
                                                    isChecked={(Array.isArray(value) && value.length > 0) || Object.values(permissionConfiguration[key]).includes(true)}
                                                />
                                            </Box>
                                        </Box>
                                        {key === 'transfer' && permissionConfiguration?.transfer?.length > 0 && (
                                            <>
                                                {Object.entries(transferTabs).map(([tKey, tValue]) => (
                                                    <Box key={key} className='item-row'>
                                                        <Text className='filter_text' sx={{ width: '80%', paddingLeft: '40px !important' }}>{tValue}</Text>
                                                        <Box sx={{ width: '20%' }}>
                                                            <Switch
                                                                size="md"
                                                                colorScheme="facebook"
                                                                value={tKey}
                                                                onChange={(e) => onChangePermissions(e, 'transfer')}
                                                                isChecked={permissionConfiguration?.transfer?.length > 0 && permissionConfiguration?.transfer?.includes(tKey)}
                                                            />
                                                        </Box>
                                                    </Box>
                                                ))}
                                            </>
                                        )}
                                    </>
                                    : <></>}
                                {key === 'profileEdit' && permissionConfiguration?.profileEdit && Object.keys(permissionConfiguration?.profileEdit)?.length ? (
                                    <>
                                        <Box className='blue-header'>
                                            <Text className='white_label'>Profile</Text>
                                        </Box>
                                        {
                                            Object.keys(defaultConfig?.profileEdit).map((subKey: any, index: number) => (
                                                <Box key={index} className='item-row'>
                                                    <Text className='filter_text' sx={{ width: '80%' }}>{tabsLabels[subKey]}</Text>
                                                    <Box sx={{ width: '20%' }}>
                                                        <Switch
                                                            size="md"
                                                            colorScheme="facebook"
                                                            value={subKey}
                                                            onChange={(e) => onChangePermissions(e, key)}
                                                            isChecked={permissionConfiguration?.profileEdit?.[subKey]}
                                                        />
                                                    </Box>
                                                </Box>
                                            ))
                                        }
                                    </>
                                ) : <></>}
                                {key === 'admin' && permissionConfiguration?.admin && permissionConfiguration?.admin.length > 0 && (
                                    <>
                                        <Box className='blue-header'>
                                            <Text className='white_label'>Admin Tabs</Text>
                                        </Box>
                                        {
                                            defaultConfig?.admin.map((subKey: any, index: number) => (
                                                <Box key={index} className='item-row'>
                                                    <Text className='filter_text' sx={{ width: '80%' }}>{tabsLabels[subKey]}</Text>
                                                    <Box sx={{ width: '20%' }}>
                                                        <Switch
                                                            size="md"
                                                            colorScheme="facebook"
                                                            value={subKey}
                                                            onChange={(e) => onChangePermissions(e, key)}
                                                            isChecked={permissionConfiguration?.admin?.includes(subKey)}
                                                        />
                                                    </Box>
                                                </Box>
                                            ))
                                        }
                                    </>
                                )}
                                {key === 'dealerSearch' && permissionConfiguration?.dealerSearch && permissionConfiguration?.dealerSearch.length > 0 && (
                                    <>
                                        {
                                            defaultConfig?.dealerSearch
                                            .filter((subKey: any) => subKey === 'IsWildCardSearchAllowed')
                                            .map((subKey: any, index: number) => (
                                                <Box key={index} className='item-row'>
                                                    <Text className='filter_text' sx={{ width: '80%', paddingLeft: '40px !important' }}>{tabsLabels[subKey]}</Text>
                                                    <Box sx={{ width: '20%' }}>
                                                        <Switch
                                                            size="md"
                                                            colorScheme="facebook"
                                                            value={subKey}
                                                            onChange={(e) => onChangePermissions(e, key)}
                                                            isChecked={permissionConfiguration?.dealerSearch?.includes(subKey)}
                                                        />
                                                    </Box>
                                                </Box>
                                            ))
                                        }
                                    </>
                                )}
                            </>
                        ))}

                    </Box>
                )}
                {isPermissionsListLoading && (
                    <Box sx={{ minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Spinner
                            className={`preview-loader`}
                            thickness={'4px'}
                            speed="0.65s"
                            emptyColor={'gray.200'}
                            color="#0C1E46"
                            size={'xl'}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    )
}
export default Permissions
